<template>
  <li v-editable="blok" class="cs-summary-item">
    <p class="cs-summary-item__title font-w-700">
      {{ blok.name }}
    </p>
    <BaseRichText
      class="cs-summary-item__description"
      :rich-text-template="description"
    />
  </li>
</template>

<script lang="ts" setup>
import type { SbCsSummaryItemStoryblok } from '@/types'
interface Props {
  blok: SbCsSummaryItemStoryblok
}
const props = defineProps<Props>()

const description = computed(() => {
  return props.blok.description !== undefined ? props.blok.description : {}
})
</script>

<style lang="scss" scoped>
.cs-summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 0;
  border-bottom: 1px solid var(--gray-400);

  @media (min-width: $breakpoint-md) {
    flex-direction: column;
  }

  @media (min-width: $breakpoint-lg) {
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }

  &:first-child {
    border-top: 1px solid var(--gray-400);
  }

  &__title {
    margin-bottom: 8px;
    font-weight: var(--font-weight-paragraph-bold);
    color: var(--cobalt-800);

    @media (min-width: $breakpoint-md) {
      flex: unset;
      margin-bottom: 8px;
    }

    @media (min-width: $breakpoint-lg) {
      flex: 0 0 100px;
      margin-bottom: 0;
    }
  }
}
</style>
